import { SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { FencingPolicyForServer, FencingPolicyModel } from '../types/FencingTypes';

export const formatFencingPolicyForSave = (policy: FencingPolicyModel) => {
    const formattedPolicy: FencingPolicyForServer = {
        ...policy,
        Protocols: policy?.Protocols.map((protocol) => protocol.value),
        Sources: policy?.Sources?.map((source) => {
            if (source.guid) {
                return { identifier: source.guid, identifierType: SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.GUID };
            } else {
                return { identifier: String(source), identifierType: SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.IP };
            }
        }),
        Destinations: policy?.Destinations?.map((dest) => {
            if (dest.guid) {
                return { identifier: dest.guid, identifierType: SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.GUID };
            } else {
                return { identifier: String(dest), identifierType: SERVICE_ACCOUNTS_ENTITY_IDENTIFIER_TYPES.IP };
            }
        })
    };

    return formattedPolicy;
};
